import './style.css';

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Spinner } from '@economic/gaudi';
import { t, useLocalization } from '../../../../shared/components/l10n/l10n';
import { RouteDisclosure } from '../../../../shared/components/RouteDisclosure';
import StepError from './StepError';
import StepOnboard from './StepOnboard';
import StepValidate from './StepValidate';
import StepConfirmStart from './StepConfirmStart';

type OnboardingPageState = { startStep?: number };
export enum OnboardingStep {
    Error = -1,
    Validate = 0,
    ConfirmStart = 1,
    Onboard = 2,
}

function MoneyflowOnboardingDialog() {
    const location = useLocation();
    const loadingTexts = useLocalization(textIds);
    const navigate = useNavigate();

    const startStep = (location.state as OnboardingPageState)?.startStep ?? 0;
    const [step, setStep] = useState(startStep);

    const disclosure = <RouteDisclosure routeTrigger={'#onboardMoneyflow'} />;

    function hide() {
        navigate(location.pathname);
    }

    function next() {
        setStep(step + 1);
    }

    function error() {
        setStep(-1);
    }

    function onboardingCompleted() {
        // if we are onboarded go back to moneyflow integration page
        navigate('/settings/integrations/moneyflow');
    }

    if (loadingTexts) {
        return (
            <Modal aria-label={t`TOAST_LOADING`} disclosure={disclosure} onHide={hide}>
                <div className="flex flex-col items-center">
                    <Spinner />
                </div>
            </Modal>
        );
    }

    return (
        <Modal
            aria-label="Moneyflow"
            disclosure={disclosure}
            onHide={hide}
            hideOnEsc={false}
            hideOnClickOutside={false}
            showCloseButton={step !== 2}
            className="moneyflow__onboarding"
            size="sm">
            {step === OnboardingStep.Error && <StepError />}
            {step === OnboardingStep.Validate && <StepValidate onDone={next} onCancel={hide} />}
            {step === OnboardingStep.ConfirmStart && <StepConfirmStart onDone={next} />}
            {step === OnboardingStep.Onboard && <StepOnboard onDone={onboardingCompleted} onCancel={hide} onError={error} />}
        </Modal>
    );
}

const textIds = [
    'TOAST_LOADING',
    'MONEYFLOW_ONBOARDING_CONFIRM_HEADER',
    'MONEYFLOW_ONBOARDING_CONFIRM_TEXT1',
    'MONEYFLOW_ONBOARDING_CONFIRM_TEXT2',
    'MONEYFLOW_ONBOARDING_CONFIRM_SHAREDDATA',
    'MONEYFLOW_ONBOARDING_CONFIRM_START_BUTTON',
    'MONEYFLOW_ONBOARDING_CONFIRM_FREE',
    'MONEYFLOW_ONBOARDING_FOOTER_PROVIDER',
    'MONEYFLOW_ONBOARDING_FOOTER_APPROVER_NAME',
    'MONEYFLOW_ONBOARDING_FOOTER_APPROVER',
    'MONEYFLOW_ONBOARDING_ERROR_UNKNOWN_HEADER',
    'MONEYFLOW_ONBOARDING_ERROR_UNKNOWN_DESCRIPTION',
    'MONEYFLOW_ONBOARDING_ERROR_VALIDATION_HEADER',
    'MONEYFLOW_ONBOARDING_ERROR_VALIDATION_CLOSE_BUTTON',
];

export default MoneyflowOnboardingDialog;
